import PageHeader from "Components/Pages/Header";
import { useScheduleContext } from "Hooks/useScheduleContext";
import { MainContent, PageContainer, PageContent } from "./styles";
import { SelectCalendar } from "./components/Steps/SelectCalendarId";
import { RegisterPersonalInfo } from "./components/Steps/RegisterPersonalInfo";
import { CheckCep } from "./components/Steps/CheckCep";

export const Schedule = () => {
  const { steps } = useScheduleContext();

  return (
    <PageContainer className="entry-app-content entry-budget">
      <PageContent>
        <div className="page-heading">
          <div className="wrapper-header-content">
            <PageHeader title="Criação de agendamento">
              <p />
            </PageHeader>
          </div>
        </div>
        <div className="separator" />
      </PageContent>

      <MainContent>
        {steps.checkCep && <CheckCep />}

        {steps.registerPersonalInfo && <RegisterPersonalInfo />}

        {steps.selectDate && <SelectCalendar />}
      </MainContent>
    </PageContainer>
  );
};
